/**
 * Mount point for the messaging watchers. It renders nothing; it exists so the
 * hooks can sit inside MessageProvider while AppShell stays a layout component.
 */
import { useConversationBadgeSync } from './useConversationBadgeSync';
import { useIncomingMessageNotices } from './useIncomingMessageNotices';

export function MessagesBackgroundSync(): null {
  useIncomingMessageNotices();
  useConversationBadgeSync();
  return null;
}
